import { render } from "./CarouselIndicators.vue?vue&type=template&id=3597f3d4&scoped=true"
import script from "./CarouselIndicators.vue?vue&type=script&lang=js"
export * from "./CarouselIndicators.vue?vue&type=script&lang=js"

import "./CarouselIndicators.vue?vue&type=style&index=0&id=3597f3d4&scoped=true&lang=css"

import exportComponent from "/Users/iammaham/Documents/JS/estate_soluce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3597f3d4"]])

export default __exports__